import * as Yup from "yup";

const ChangePasswordSchema = Yup.object().shape({
  currentPassword: Yup.string().required("Your current password is required"),
  newPassword: Yup.string()
    .trim()
    .min(8, "Too short minimum 8 characters")
    .max(30, "Too long maximum 30 characters")
    .matches(
      /^(?=.*[0-9]+.*)(?=.*[a-zA-Z]+.*)[0-9a-zA-Z]{8,30}$/,
      "Password must contain at least one letter and at least one number"
    )
    .notOneOf(
      [Yup.ref("currentPassword")],
      "New password must be different from your current password"
    )
    .required("New password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword")], "Passwords do not match")
    .required("Please confirm your new password"),
});

export default ChangePasswordSchema;
